import { jsx as _jsx } from "react/jsx-runtime";
export const SourgumFortyYdDimensions2 = (props) => {
    const src = new URL('./dumpster-40.png', import.meta.url).toString();
    return _jsx("img", { ...props, src: src, alt: "Forty Yard Dimensions" });
};
//# sourceMappingURL=forty-yard-dimensions-sourgum2.js.map